// src/pages/ChicagoTour.jsx
import MissionTourApp from "../MissionTourApp";
import { CHICAGO_TOUR } from "../data/tours/chicagoTourData";

export default function ChicagoTour() {
  return <MissionTourApp tourData={CHICAGO_TOUR} />;
}
